import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=206ae6a5&scoped=true&"
import script from "./Tooltip.vue?vue&type=script&lang=js&"
export * from "./Tooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ae6a5",
  null
  
)

export default component.exports